// @ts-strict-ignore

export const robotsContent = ({ robotsMeta = ['all'] }) => robotsMeta.join(',').trim()

export const canonicalHref = ({ canonical, href }) => {
  const url = new URL(canonical || href)

  url.protocol = 'https:'
  url.search = ''
  return url.toString()
}
